export default class App {
  static hasGlobalMessage() {
    return process.env.VUE_APP_GLOBAL_MESSAGE_ACTIVATOR === 'true';
  }

  static isGlobalMessageError() {
    return process.env.VUE_APP_GLOBAL_MESSAGE_TYPE === 'error';
  }

  static isGlobalMessageWarning() {
    return process.env.VUE_APP_GLOBAL_MESSAGE_TYPE === 'warning';
  }

  static environment() {
    return process.env.VUE_APP_ENVIRONMENT;
  }

  static isProductionBuild() {
    return process.env.NODE_ENV === 'production';
  }

  static isProduction() {
    return process.env.VUE_APP_ENVIRONMENT === 'production';
  }

  static isDevelopment() {
    return process.env.VUE_APP_ENVIRONMENT === 'development';
  }

  static isStaging() {
    return process.env.VUE_APP_ENVIRONMENT === 'staging';
  }

  static isTest() {
    return process.env.VUE_APP_ENVIRONMENT === 'test';
  }

  static isMock() {
    return process.env.VUE_APP_ENVIRONMENT === 'mock';
  }

  static isMultilingual() {
    return process.env.VUE_APP_ENABLE_LANGUAGE_SELECTOR === 'true';
  }

  static getDefaultLocale() {
    return process.env.VUE_APP_DEFAULT_LOCALE;
  }

  static getLocaleOrigin() {
    return process.env.VUE_APP_LOCALE_ORIGIN;
  }

  static getMarketIdentifier() {
    return process.env.VUE_APP_MARKET_IDENTIFIER;
  }

  static getDesktopLogo() {
    return `IconLogoDesktop${process.env.VUE_APP_MARKET_IDENTIFIER}`;
  }

  static getMobileLogo() {
    return `IconLogoMobile${process.env.VUE_APP_MARKET_IDENTIFIER}`;
  }

  static isMockedAPI() {
    return process.env.VUE_APP_MOCK_API === 'true';
  }

  static getName() {
    return process.env.VUE_APP_NAME ? process.env.VUE_APP_NAME : 'app';
  }

  static getEnvironment() {
    return process.env.NODE_ENV;
  }

  static getGlobalMessage() {
    return process.env.VUE_APP_GLOBAL_MESSAGE;
  }

  static getPublicPath() {
    return process.env.VUE_APP_PUBLIC_PATH;
  }

  static getRouterBase() {
    return process.env.VUE_APP_ROUTER_BASE;
  }

  static getTranslationsAPIBaseUrl() {
    return process.env.VUE_APP_TRANSLATIONS_API_BASE_URL;
  }

  static getTranslationsDefaultProject() {
    return process.env.VUE_APP_TRANSLATIONS_DEFAULT_PROJECT;
  }

  static getTranslationsMinimalLogLevel() {
    return process.env.VUE_APP_TRANSLATIONS_MINIMAL_ERROR_LEVEL;
  }

  static getHostURL() {
    return process.env.VUE_APP_PROXY_URL;
  }

  static getAPIPingHost() {
    return process.env.VUE_APP_PING_URL;
  }

  static getLoginURL() {
    return process.env.VUE_APP_LOGIN_URL ? process.env.VUE_APP_LOGIN_URL : '/app/login';
  }

  static getUploadURL() {
    return process.env.VUE_APP_UPLOAD_URL ? process.env.VUE_APP_UPLOAD_URL : '/upload';
  }

  static analyticsEnabled() {
    return process.env.VUE_APP_ANALYTICS_ACTIVATED === 'true';
  }

  static analyticsLogging() {
    return process.env.VUE_APP_ANALYTICS_LOG === 'true';
  }
}
